<template>
    <div class="table-simple-modal" style="max-height: 60vh; overflow-y: auto;">

        <b-row v-if="Object.keys(tableData).length > 0">
            <b-col cols="12" md="6">
                <p>
                    <span class="font-weight-600">Property Value:</span>
                    RM {{ tableData[0].property_value }}
                </p>
            </b-col>
            <b-col cols="12" md="6">
                <p>
                    <span class="font-weight-600">Loan Margin:</span>
                    RM {{ tableData[0].loan_margin }}
                </p>
            </b-col>
            <b-col cols="12" md="6">
                <p>
                    <span class="font-weight-600">Loan Amount:</span>
                    RM {{ tableData[0].loan_amount }}
                </p>
            </b-col>
        </b-row>
        
        <b-table-simple responsive bordered class="mt-4">
            <b-thead>
                <b-tr>
                    <b-th>Bank</b-th>
                    <b-th>Net Salary Income</b-th>
                    <b-th>Interest Rate</b-th>
                    <b-th>Loan Term in Years</b-th>
                    <b-th>Target Instalment</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(bank, index) in tableData" :key="index">
                    <b-td>{{ bank.bank_name }}</b-td>
                    <b-td variant="success">RM {{ bank.net_income }}</b-td>
                    <b-td>{{ bank.interest_rate_percent }}</b-td>
                    <b-td>{{ bank.loan_years }} Years</b-td>
                    <b-td>RM {{ bank.target_instalment }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>
<script>
export default {
    props: {
        tableData: Array | Object,
    }
}
</script>